export default [
  { 
    path: 'create/', 
    name: 'QuotationAdd',
    meta: { 
      title: 'Add Quotation',
      masterModal: 'create'
    }
  },
  {
    path: 'edit/:quotationId',
    name: 'QuotationEdit',
    meta: { 
      title: 'Edit Quotation',
      masterModal: 'edit'
    }
  },
  {
    path: 'view/:quotationId',
    name: 'QuotationView',
    meta: { 
      title: 'View Quotation',
      masterModal: 'view'
    }
  },
  {
    path: 'send/', 
    name: 'QuotationSendHomeNew',
    meta: { 
      title: 'Send Quotations',
      masterModal: 'send'
    },
    children: [
      { 
        path: ':quotationId', 
        name: 'QuotationSend',
        meta: { 
          title: 'Send Quotations',
          masterModal: 'send'
        }
      },
      { 
        path: ':quotationId/:emailMessageId', 
        name: 'QuotationSend',
        meta: { 
          title: 'Send Quotations',
          masterModal: 'send'
        }
      },
    ]
  }
]
